import { Checkbox, Divider, Select, Tag } from "antd";
import clsx from 'clsx';
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Text = styled.span`
    margin: 0;
    display: flex;
    margin-left: 5px;
    
    & div {
        margin: 0;
        margin-left: 5px;
        color: #97999B;
    }
`;

export const MultipleSelectAtomic = ({ handleOptionsChange, optionsData, defaultValue, isToDisable, size, fullWidth, placeholder, isModal, allAvailable, disabled, onChange,
    loading, initialValue, ...props
}) => {

    const { t } = useTranslation();
    const noTags = props?.noTags;

    const [selectedOption, setSelectedOption] = useState(() => {
        if (initialValue) {
            return initialValue;
        } else {
            return defaultValue;
        }
    });

    const checkAll = optionsData?.length === selectedOption?.length;

    /**
     * Updates the selected options with the provided values.
     * If the values are not in object format, they will be formatted before updating.
     * @param {Array} newValues - The new values to update the selected options with.
     */
    const updateSelectedOptions = (newValues) => {
        let formattedValues;

        if (newValues.length > 0 && typeof newValues[0] === "object") {
            formattedValues = newValues;
        } else {
            formattedValues = newValues.map((value) => ({
                label: value,
                value,
            }));
        }

        setSelectedOption(formattedValues);

        if (handleOptionsChange) {
            handleOptionsChange(placeholder, formattedValues);
        }

        if (onChange) {
            onChange(formattedValues);
        }
    };

    useEffect(() => {
        if (defaultValue && JSON.stringify(defaultValue) !== JSON.stringify(selectedOption)) {
            updateSelectedOptions(defaultValue);
        }
    }, [defaultValue]);

    return (
        <Select
            bordered={!isModal}
            mode="multiple"
            size='large'
            disabled={disabled}
            placeholder={<span style={{ color: 'lightgrey' }}>{t(placeholder)}</span>}
            value={selectedOption}
            onChange={(e) => {
                updateSelectedOptions(e);
            }}
            labelInValue
            loading={loading}
            dropdownRender={menu => (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 8px 0px 8px' }}>
                        {allAvailable ?
                            <Checkbox
                                indeterminate={selectedOption?.length > 0 && selectedOption?.length < 3}
                                onChange={(e) => {
                                    const allValues = e.target.checked ? optionsData.map(x => x.value) : [];
                                    updateSelectedOptions(allValues);
                                }}
                                checked={checkAll}
                            >
                                {t('All')}
                            </Checkbox>
                            : null}
                        <a
                            onClick={() => updateSelectedOptions([])}
                            style={{ float: 'right', padding: '5px 8px', fontSize: 'x-small' }}>
                            {t('Clear Options')}
                        </a>
                    </div>
                    <Divider style={{ margin: '8px 0' }} />
                    <div style={{ padding: '8px', display: 'flex', flexDirection: 'column', maxHeight: '200px', overflowY: 'auto' }}>
                        {optionsData?.map((option) => {
                            return (
                                <Checkbox
                                    key={option.value}
                                    value={option.value}
                                    checked={selectedOption.find(item => item.value === option.value) ? true : false}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const updatedValues = e.target.checked
                                            ? [...selectedOption.map(x => x.value), value]
                                            : selectedOption.map(x => x.value).filter(v => v !== value);

                                        updateSelectedOptions(updatedValues);
                                    }}
                                    style={{ padding: '5px 0px' }}
                                >
                                    {t(option.label)}
                                </Checkbox>
                            )
                        })}
                    </div>
                </div>
            )}
            className={clsx('multiple-select-atomic', props?.className, fullWidth ? 'full-width' : '')}
            tagRender={props => {
                const { label, value, closable, onClose } = props;
                const renderPlaceholder = selectedOption[0].label === label;
                return (
                    <>
                        {renderPlaceholder ? <div style={{ margin: '0 5px', fontSize: 'small', color: 'grey' }}>{t(placeholder)}</div> : null}
                        {
                            noTags ?
                                renderPlaceholder ? <Text>{t(label)} {selectedOption && selectedOption?.length > 1 ? <div>{t('and others')}</div> : null}</Text> : null
                                :
                                <Tag
                                    // color="blue"
                                    closable={closable}
                                    onClose={onClose}
                                    style={{ margin: 2 }}
                                >
                                    {t(label)}
                                </Tag>
                        }
                    </>
                );
            }}
        >
        </Select >)
}